<app-admin-header></app-admin-header>

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div class="main-content p-t-20">
    <div class="container-fluid">
      <app-breadcrumb
        [items]="[{ label: 'Admin' }, { label: 'Timelines' }]"
        [home]="{ label: 'Home', routerLink: '/home' }"
      ></app-breadcrumb>

      <div>
        <h1 class="font-medium m-b-0">Preferred Timeline Configuration</h1>
      </div>

      <div>
        <form
          class="row m-t-20"
          [formGroup]="timelineForm"
          (ngSubmit)="onSubmit()"
        >
          <div class="col-md-12">
            <!-- Planning Timeline -->
            <div class="dis-flex flex-m planning-timeline">
              <div>Planning starts on</div>
              <div class="mx-2">
                <input
                  type="text"
                  class="b2 text-primary wd-60px text-center p-l-0"
                  formControlName="plan_start_day"
                />
              </div>
              <div>of</div>
              <div class="mx-2">
                <p-multiSelect
                  [options]="months"
                  formControlName="plan_start_months"
                  [overlayOptions]="helper.getOverlayOptions()"
                  [filter]="false"
                  optionLabel="name"
                  placeholder="Select Months"
                  optionValue="value"
                  class="timeline-month-dd select-no-header fs-16"
                  (onChange)="filterDropdownOptions()"
                ></p-multiSelect>
              </div>
              <div>with start month as</div>
              <div class="mx-2">
                <p-dropdown
                  [options]="filteredMonths"
                  formControlName="plan_start_month"
                  [filter]="false"
                  optionLabel="name"
                  optionValue="value"
                  placeholder="Select Month"
                  class="select-no-header"
                ></p-dropdown>
              </div>
              <div>on</div>
              <div class="mx-2">
                <p-dropdown
                  [options]="dayType"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="plan_start_day_type"
                  optionLabel="name"
                  optionValue="value"
                  class="select-no-header"
                ></p-dropdown>
              </div>
            </div>

            <!-- Implementation Timeline -->
            <div class="disflex flex-m implementation-timeline mt-3">
              <div>Implementation starts after</div>
              <div class="mx-2">
                <input
                  type="text"
                  class="b2 text-primary wd-60px text-center p-l-0"
                  formControlName="implementation_start_delay"
                />
              </div>
              <div>days on</div>
              <div class="mx-2">
                <p-dropdown
                  [options]="dayType"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="implementation_start_day_type"
                  optionLabel="name"
                  optionValue="value"
                  class="select-no-header"
                ></p-dropdown>
              </div>
              <div>and ends after</div>
              <div class="mx-2">
                <input
                  type="text"
                  class="b2 text-primary wd-60px text-center p-l-0"
                  formControlName="implementation_end_delay"
                />
              </div>
              <div>days from the plan start date</div>
            </div>

            <!-- Review Timeline -->
            <div class="dis-flex flex-m review-timeline mt-3">
              <div>Review starts after</div>
              <div class="mx-2">
                <input
                  type="text"
                  class="b2 text-primary wd-60px text-center p-l-0"
                  formControlName="review_start_delay"
                />
              </div>
              <div>days on</div>
              <div class="mx-2">
                <p-dropdown
                  [options]="dayType"
                  [overlayOptions]="helper.getOverlayOptions()"
                  formControlName="review_start_day_type"
                  optionLabel="name"
                  optionValue="value"
                  class="select-no-header"
                ></p-dropdown>
              </div>
              <div>and ends after</div>
              <div class="mx-2">
                <input
                  type="text"
                  class="b2 text-primary wd-60px text-center p-l-0"
                  formControlName="review_end_delay"
                />
              </div>
              <div>days from the plan start date</div>
            </div>
          </div>
          <div class="dis-flex justify-content-between">
            <button type="submit" class="btn success wd-100px m-t-20">
              Save
            </button>

            <button
              type="button"
              (click)="onFutureIteration()"
              class="btn success wd-150px"
            >
              Future Iterations
            </button>
          </div>
        </form>
      </div>
      <hr />

      <!-- <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 65vh)' }">
        <div class="timelines-table">
          <p-table
            [paginator]="true"
            [totalRecords]="totalRecords"
            [value]="timeLines"
            [rows]="4"
            [tableStyle]="{ 'min-width': '50rem' }"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 10%"></th>
                <th style="width: 15%">Quarter</th>
                <th style="width: 25%">Planning</th>
                <th style="width: 20%">Implementation</th>
                <th style="width: 20%">Review</th>
                <th style="width: 10%">Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
              <tr>
                <td>
                  @if(data.plan_start>currentDate){
                  <div
                    [ngClass]="'status notstart'"
                    ngbTooltip="Not started yet"
                  ></div>
                  } @else if(data.implement_end<=currentDate){
                  <div [ngClass]="'status complete'" ngbTooltip="Completed"></div>
                  }@else {
                    <div [ngClass]="'status progress'" ngbTooltip="In Progress"></div>
                  }
                </td>
                <td>Q{{ data.quarter }} - {{ data.year }}</td>
                <td>
                  {{ data.plan_start | dateFormatPipe }} -
                  {{ data.plan_end | dateFormatPipe }}
                </td>
                <td>
                  {{ data.implement_start | dateFormatPipe }} -
                  {{ data.implement_end | dateFormatPipe }}
                </td>
                <td>
                  {{ data.review_start | dateFormatPipe }} -
                  {{ data.review_end | dateFormatPipe }}
                </td>
                <td>
                  <button
                    type="button"
                    class="icon-btn"
                    pRipple
                    (click)="selectTimelineData(data)"
                  >
                    <ng-icon name="hugeEdit02"></ng-icon>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-scrollPanel> -->

      <div class="timelines-table">
        <app-virtual-scroll
          class="w-full"
          [data]="timeLineListPayload"
          [apiUrl]="timeLineUrl"
          (loadedData)="onDataLoaded($event)"
        >
          <ng-container *ngIf="!loading; else loadingData">
            <table class="scrollable-table">
              <thead>
                <tr>
                  <th style="width: 10%" class="text-center"></th>
                  <th style="width: 15%">Cycle</th>
                  <th style="width: 25%">Planning</th>
                  <th style="width: 20%">Implementation</th>
                  <th style="width: 20%">Review</th>
                  <th style="width: 10%" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of timeLines">
                  <td>
                    @if (data.plan_start > currentDate) {
                    <div
                      class="status notstart m-l-r-auto"
                      ngbTooltip="Not started yet"
                    ></div>
                    } @else if (data.implement_end <= currentDate) {
                    <div
                      class="status complete m-l-r-auto"
                      ngbTooltip="Completed"
                    ></div>
                    } @else {
                    <div
                      class="status progress m-l-r-auto"
                      ngbTooltip="In Progress"
                    ></div>
                    }
                  </td>
                  <td>Cycle {{ data.quarter }} - {{ data.year }}</td>
                  <td>
                    {{ data.plan_start | dateFormatPipe }} -
                    {{ data.plan_end | dateFormatPipe }}
                  </td>
                  <td>
                    {{ data.implement_start | dateFormatPipe }} -
                    {{ data.implement_end | dateFormatPipe }}
                  </td>
                  <td>
                    {{ data.review_start | dateFormatPipe }} -
                    {{ data.review_end | dateFormatPipe }}
                  </td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="icon-btn"
                      pRipple
                      (click)="selectTimelineData(data)"
                    >
                      <ng-icon name="hugeEdit02"></ng-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </app-virtual-scroll>
      </div>

      <p-dialog
        class="action-item-modal b1 font-medium"
        header="Update Timeline"
        [modal]="true"
        [(visible)]="visible"
        [style]="{ width: '80rem' }"
      >
        <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-25">
          <form [formGroup]="dateRangeForm" (ngSubmit)="updateDateRangeForm()">
            <p-scrollPanel
              [style]="{ width: '100%', height: 'calc(100vh - 35vh)' }"
            >
              <div
                class="timeline-form-container radius-8 border-20 p-t-15 p-b-15 p-l-15 p-r-15"
              >
                <div formArrayName="dateRanges" class="mt-3">
                  <div class="row">
                    <div class="col-md-2">
                      <h3 class="">Group:</h3>
                    </div>
                    <div class="col-md-3">
                      <h3 class="">Planning:</h3>
                    </div>
                    <div class="col-md-3">
                      <h3 class="">Implementation:</h3>
                    </div>
                    <div class="col-md-4">
                      <h3 class="">Review:</h3>
                    </div>
                  </div>

                  <div
                    class="m-b-10"
                    *ngFor="let dateRange of dateRanges.controls; let i = index"
                    [formGroupName]="i"
                  >
                    <div class="row">
                      <div class="col-md-2">
                        <p-dropdown
                          formControlName="group_id"
                          [options]="groupListItem"
                          placeholder="Select group"
                          optionLabel="name"
                          optionValue="group_id"
                          filter="true"
                          [overlayOptions]="helper.getOverlayOptions()"
                        />
                      </div>
                      <div class="col-md-3 dis-flex">
                        <p-calendar
                          formControlName="plan_start"
                          dateFormat="M d, yy"
                          class="wd-120px fs-14 me-2"
                        />
                        <p-calendar
                          formControlName="plan_end"
                          dateFormat="M d, yy"
                          class="wd-120px fs-14"
                        />
                      </div>
                      <div class="col-md-3 dis-flex">
                        <p-calendar
                          formControlName="implement_start"
                          dateFormat="M d, yy"
                          class="wd-120px fs-14 me-2"
                        />
                        <p-calendar
                          formControlName="implement_end"
                          dateFormat="M d, yy"
                          class="wd-120px fs-14"
                        />
                      </div>
                      <div class="col-md-4 dis-flex">
                        <p-calendar
                          formControlName="review_start"
                          dateFormat="M d, yy"
                          class="wd-120px fs-14 me-2"
                        />
                        <p-calendar
                          formControlName="review_end"
                          dateFormat="M d, yy"
                          class="wd-120px fs-14"
                        />
                        <button
                          type="button"
                          class="icon-btn m-l-20 m-t-5"
                          [ngStyle]="{ color: i == 0 ? '#A2A9B0' : '#FF1F26' }"
                          pRipple
                          (click)="removeDateRange(i)"
                          [disabled]="i == 0 ? true : false"
                        >
                          <ng-icon name="hugeDelete02"></ng-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </p-scrollPanel>
            <div class="dis-flex flex-sb m-t-20 m-b-20">
              <div>
                <button
                  type="button"
                  (click)="resetDateRanges()"
                  class="btn black wd-150px m-r-10"
                >
                  Reset
                </button>
              </div>
              <div class="dis-flex">
                <button
                  type="button"
                  (click)="addDateRange(intialFormData)"
                  class="btn outline wd-150px m-r-10"
                >
                  Add Exception
                </button>
                <button type="submit" class="btn primary wd-150px">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </p-dialog>
    </div>
  </div>
</div>
<ng-template #loadingData>
  <app-shimmer-list></app-shimmer-list>
</ng-template>
